import { CircularProgress, IconButton } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import HistoryIcon from '@mui/icons-material/History';
import { IoArrowUp as IoArrowUpIcon } from 'react-icons/io5';
import { styled } from '@mui/material/styles';
import ChatIcon from '@mui/icons-material/Chat';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React from 'react';

const IoArrowUp = IoArrowUpIcon as React.ComponentType<{ size?: number; color?: string }>;

export const PrimaryRobotIcon = styled(SmartToyIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const PrimaryHistoryIcon = styled(HistoryIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const PrimaryCircularProgress = styled(CircularProgress)(() => ({
  color: 'white',
}));

export const WhiteIoArrowUp = styled(IoArrowUp)(() => ({
  color: 'white',
}));

export const WhiteChatIcon = styled(ChatIcon)(() => ({
  color: 'white',
}));

export const CustomChatBubbleIcon = styled(ChatBubbleOutlineIcon)(({ theme }) => ({
  fontSize: 32,
  [theme.breakpoints.up('md')]: {
    fontSize: 40,
  },
}));

export const CustomCloseIconButton = styled(IconButton)(() => ({
  width: 32,
  height: 32,
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: '#EDF2F7',
    transform: 'scale(1.1)',
  },
}));
 